<template>
  <ion-app>
    <div v-show="showFullLoader" class="no-freeze-spinner" id="preloaderAppVue">
      <div id="no-freeze-spinner">
        <div>
          <i class="mdi mdi-store"> </i>
          <i class="mdi mdi-cart-variant"> </i>
          <i class="mdi mdi-shopping"> </i>
          <div></div>
        </div>
      </div>
    </div>
    <ion-router-outlet id="main" class="app-bg" />
    <fab-products
      v-show="!routeNoShowFabPL.includes($route.name)"
    ></fab-products>
  </ion-app>
</template>

<script>
import {
  IonApp,
  IonRouterOutlet,
  toastController,
  actionSheetController,
  modalController
} from '@ionic/vue'
import FabProducts from '@/components/product/fab_products.vue'
import mdlZoomImage from '@/components/media/view_image_component.vue'
import mdlMessageForm from '@/components/contact/contact_form_component.vue'
export default {
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    FabProducts
  },
  data: () => ({
    mcMotoCollection: [],
    showFullLoader: false,
    isOpenRef: false,
    toast: null,
    routeNoShowFabPL: [
      'contact',
      'home',
      'product-detail',
      'view-image',
      'messageme',
      'product-image-list'
    ],
    mdlZoomImageCtrl: null,
    mdlMessageFormCtrl: null
  }),
  computed: {},
  watch: {},
  created() {
    this.$emitter.on('toast', (e) => {
      this.openToast(e)
    })
    this.$emitter.on('full-loader', (e) => {
      if (e && e.open) this.showFullLoader = true
      else this.showFullLoader = false
    })
    this.$emitter.on('open-fpl', () => {
      this.getMcMoto()
    })
  },
  beforeUnmount() {
    this.$emitter.off('toast')
    this.$emitter.off('full-loader')
    this.$emitter.off('open-fpl')
  },
  async mounted() {
    if (this.$store.state.app.orientation === 'landscape') {
      this.$emitter.emit('toast', {
        message: 'Gire su dispositivo para una mejor experiencia',
        color: 'warning'
      })
    }
    window.addEventListener('orientationchange', (event) => {
      if (event.target.screen.orientation.angle > 0) {
        this.$store.dispatch('app/setOrientation', 'landscape')
        this.$emitter.emit('toast', {
          message: 'Gire su dispositivo para una mejor experiencia',
          color: 'warning'
        })
      } else {
        this.$store.dispatch('app/setOrientation', 'portrait')
      }
    })
    document.body.classList.toggle('dark', true)
    await this.$http
      .get('app-mobile/get-mc-moto')
      .then((res) => {
        this.mcMotoCollection = res.data.data
      })
      .catch((err) => {
        console.log(err)
      })
    await this.$http({ url: '/', baseURL: window.location.origin })
      .then((res) => {
        var el = document.getElementById('appPreLoading')
        if (el) el.remove()
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    async openMessageForm(e) {
      let propsComp = e
      this.mdlMessageFormCtrl = await modalController.create({
        component: mdlMessageForm,
        componentProps: propsComp
      })
      return this.mdlMessageFormCtrl.present()
    },
    async zoomImage(img) {
      this.mdlZoomImageCtrl = await modalController.create({
        component: mdlZoomImage,
        componentProps: {
          imagep: img
        }
      })
      return this.mdlZoomImageCtrl.present()
    },
    async openToast(options) {
      if (this.toast) {
        await this.toast.dismiss()
      }
      this.toast = await toastController.create({
        message: options.message || 'no hay mensaje',
        duration: 2000,
        cssClass: 'app-toast-style',
        color: options.color || 'primary',
        buttons: [
          {
            text: 'Ok',
            role: 'cancel',
            handler: () => {}
          }
        ]
      })
      return this.toast.present()
    },
    getMcMoto() {
      this.showMcmoto()
    },
    async showMcmoto() {
      let buttons = []
      this.mcMotoCollection.forEach((el) => {
        let itemMcMoto = {
          text: el.descripcion,
          handler: () => {
            this.showMdmoto(el)
          }
        }
        buttons.push(itemMcMoto)
      })
      buttons.push({
        text: 'Cancelar',
        role: 'cancel',
        handler: () => {}
      })

      const actionSheet = await actionSheetController.create({
        header: 'Seleccione Su Moto',
        cssClass: 'mdmoto-asheet',
        buttons: buttons
      })
      return actionSheet.present()
    },
    async showMdmoto(item) {
      let buttons = []
      item.modelomoto.data.forEach((el) => {
        let itemMcMoto = {
          text: el.descripcion,
          handler: () => {
            this.$store.dispatch('app/keepPageState', false)
            this.$router.push({
              name: 'product-list',
              params: {
                motobrand: item.descripcion_hide,
                motomodel: el.descripcion_hide,
                motomodel_id: el.id
              }
            })
          }
        }
        buttons.push(itemMcMoto)
      })
      buttons.push({
        text: 'Cancelar',
        role: 'cancel',
        handler: () => {}
      })

      const actionSheet = await actionSheetController.create({
        header: 'Seleccione un modelo',
        cssClass: 'mdmoto-asheet',
        buttons: buttons
      })
      return actionSheet.present()
    }
  }
}
</script>
<style>
.app-toast-style {
  color: #ffffff;
}
.cursor-default {
  cursor: default;
}
ion-thumbnail img {
  border-radius: 50px;
}
.color-red {
  color: red;
}
.color-green {
  color: green;
}
#preloaderAppVue {
  z-index: 30000;
}
.grecaptcha-badge {
  visibility: hidden;
}
.lionInputNormal {
  --border-color: var(--ion-color-medium-shade);
  --border-radius: 5px;
  --border-width: 1px;
  --box-shadow: 2px gray;
  --highlight-height: 0;
  --background: var(--ion-lion-form-normal-bg);
}
.lionInputError {
  --border-color: var(--ion-color-medium-shade);
  --border-radius: 5px;
  --border-width: 1px;
  --box-shadow: 2px gray;
  --highlight-height: 0;
  --background: var(--ion-lion-form-error-bg);
}

ion-item {
  --highlight-color-focused: none;
}

ion-item.item-has-focus > ion-label {
  color: #ffffff !important;
}

.page-bg {
  background: rgba(0, 0, 0, 0.87);
}

.ios .title-default {
  text-align: start;
}
.action-sheet-group.action-sheet-group-cancel.sc-ion-action-sheet-ios {
  border-radius: 10px;
}
.sc-ion-action-sheet-ios {
  color: #e0e1e7;
}
.button-clear {
  --background-hover-opacity: 0;
}
.ion-text-color-withe {
  color: #fff;
}
.action-sheet-group {
  border-radius: 10px 10px 0px 0px;
}
.action-sheet-group.action-sheet-group-cancel {
  border-radius: 0px;
}

.bg-grad-content {
  /* --background: linear-gradient(
    180deg,
    rgb(0, 0, 0) 25%,
    rgb(138, 133, 133) 100%
  ); */
  --background: rgba(0, 0, 0, 0.397);
}
.app-bg {
  background: -webkit-radial-gradient(
      center,
      circle,
      rgba(255, 255, 255, 0.35),
      rgba(255, 255, 255, 0) 20%,
      rgba(255, 255, 255, 0) 21%
    ),
    -webkit-radial-gradient(center, circle, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)
          20%, rgba(0, 0, 0, 0) 21%),
    -webkit-radial-gradient(center, circle farthest-corner, #929292, #2e2c2c);
  background-size: 10px 10px, 10px 10px, 100% 100%;
  background-position: 1px 1px, 0px 0px, center center;
}
</style>
